import { render, staticRenderFns } from "./UsersSectionSearch.vue?vue&type=template&id=a540f760&scoped=true&"
import script from "./UsersSectionSearch.vue?vue&type=script&lang=js&"
export * from "./UsersSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a540f760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
